module.exports = __webpack_public_path__ + "static/media/imtbike_logo.7dcef614.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/imtbike_logo.png
// module id = 8296
// module chunks = 2